/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function ($) {
  'use strict';
  /**
   * Вид для селекта
   */
  app.SelectView = app.View.extend({
    optionsTemplateName: '.options-template',
    optionsSelector: '.js-options',
    defaultValue: 0,
    events: {
      'click .select_active': 'showPopup',
      'click li:not(.disabled)': 'selectOption',
      'click .arrow_down': 'showPopup',
      'click .arrow_up': 'hidePopup'
    },
    additionalOptions: ['optionsTemplateName', 'optionsSelector', 'inputSelector', 'activeValueSelector', 'field'],
    run: function () {
      this.defaultNameTemplate = app.helpers.TemplateHelper.getTemplate('#select-view-default-name-template');
      if (!this.field) {
        throw new Error('You will definitely need a field or why are you starting this?');
      }
      this.listenTo(Backbone, 'bodyView:click', this.bodyClick);
      this.optionsTemplate = app.helpers.TemplateHelper.getTemplate(this.optionsTemplateName);
      this.selectInput = this.$(this.inputSelector);
      this.selectOptions = this.$(this.optionsSelector);
      this.activeValue = this.$(this.activeValueSelector);
      this.popupOpen = false;
    },
    arrowSelectUp: function () {
      this.$('.arrow_down').addClass('arrow_up');
    },
    arrowSelectDown: function () {
      this.$('.arrow_down').removeClass('arrow_up');
    },
    /**
     * Отображение блока с опциями.
     */
    showPopup: function (event) {
      event.stopPropagation();
      this.$(event.currentTarget).blur();
      this.popupOpen = true;
      this.$('.b-popup').removeClass('not_display');
      this.arrowSelectUp();
    },
    /**
     * Скрытие блока с опциями.
     */
    hidePopup: function (e) {
      if (e) {
        e.preventDefault();
      }
      if (this.popupOpen) {
        this.$('.b-popup').addClass('not_display');
        this.arrowSelectDown();
        this.popupOpen = false;
      }
    },
    /**
     * Выбор опции.
     * @param {object} e
     */
    selectOption: function (e) {
      var target = $(e.currentTarget),
        text = target.text(),
        id = target.data('id');
      if (this.model.get(this.field) !== id) {
        if (this.activeValue.length) {
          this.selectInput.val(id);
          this.activeValue.html(text);
        } else {
          this.selectInput.val(text);
        }
        this.model.set(this.field, id);
      }
    },
    /**
     * Рендеринг опций селекта.
     */
    render: function (value, name) {
      name = name || this.defaultNameTemplate();
      value = value || this.defaultValue;
      this.selectInput.val(value);
      this.activeValue.html(name);
      this.selectOptions.html(this.optionsTemplate({
        options: this.model.get('values'),
        //на время кэша шаблонов
        obj: this.model.get('values')
      }));
      return this;
    },
    /**
     * Рендерит текст активной опции.
     */
    renderActiveValue: function () {
      var val = this.selectInput.val(),
        activeOption = this.selectOptions.find('[data-id=' + val + ']').html();
      this.activeValue.html(activeOption);
    }
  });

  _.extend(app.SelectView.prototype, app.ClosePopupMixin);

})(jQuery);


}.call(window));